import { Drawer } from '@servicetitan/anvil2';
import { useEffect, useRef } from 'react';

interface TermsDrawerProps {
    open: boolean;
    onClose: () => void;
    terms: string | null | undefined;
}

export const TermsDrawer = ({ open, onClose, terms }: TermsDrawerProps) => {
    const content = terms ?? 'Final terms will be provided in your loan agreement.';
    const drawerContentRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (open) {
            const scrollToTop = () => {
                // Find the actual scrollable container by traversing up the DOM
                const scrollableElement = drawerContentRef.current;

                if (scrollableElement) {
                    // Try scrolling the ref element first
                    scrollableElement.scrollTo(0, 0);
                }
            };

            // Use requestAnimationFrame to ensure DOM is ready
            const performScroll = () => {
                requestAnimationFrame(() => {
                    scrollToTop();
                });
            };

            setTimeout(performScroll, 150);
        }
    }, [open]);

    return (
        <Drawer open={open} onClose={onClose} ref={drawerContentRef}>
            <Drawer.Header>Terms</Drawer.Header>
            <Drawer.Content>
                <div style={{ whiteSpace: 'pre-line' }}>{content}</div>
            </Drawer.Content>
            <Drawer.Footer>
                <Drawer.CancelButton>Close</Drawer.CancelButton>
            </Drawer.Footer>
        </Drawer>
    );
};
